import { useStore } from "@nanostores/react"

import { atom } from "nanostores"

const isLoggedInAtom = atom<boolean | undefined>(undefined)

export function setLoginStatus(status: boolean | undefined) {
  return isLoggedInAtom.set(status)
}

export function useLoginStatus() {
  return useStore(isLoggedInAtom)
}
